import React from 'react';
import './Certificate.css';
import { Link } from 'react-router-dom';

function Certificate() {
  return (
    <div className='certificate-outer'>
      <div className="certificate-inner">
        <h2 className="header-text">Get Your Certificate In <br/>Hotel Management</h2>
        <button className="cta-text"><Link to='/contact'>Admission Open</Link></button>
      </div>
    </div>
  )
}

export default Certificate
